import { BorderedRadioListField } from 'lib/iterable-hook-form/FormField';
import styled from 'styled-components';
import { Banner } from 'ui/banner';
import { FormField } from 'ui/formField';
import { AiColor16 } from 'ui/icons';
import { ModalFooter } from 'ui/modal';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  iconTopPadding: pxToRem(7),
};

const BaseExperimentTypeOption = `
  gap: ${spacing.base};

  > * {
  margin: 0;
  }
`;
const FlexOptionStyles = `
  ${BaseExperimentTypeOption}
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex-direction: row;
  align-items: stretch;
`;

export const ExperimentTypeOptions = styled(BorderedRadioListField)`
  ${FlexOptionStyles}
  padding-top: ${spacing.half};
  padding-bottom: ${spacing.base};
`;

export const FormFieldWithTopPadding = styled(FormField)`
  padding-top: ${spacing.half};
`;

export const LightningIcon = styled(AiColor16)`
  margin-top: ${customSpacing.iconTopPadding};
`;

export const StyledBanner = styled(Banner)`
  margin-bottom: ${spacing.base};
`;

export const StyledModalFooter = styled(ModalFooter)`
  padding: ${spacing.base} ${spacing.plusThreeQuarter};
`;
